import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { usePlayerListsQuery } from 'api/feeds';
import { Overlays } from '../overlays';
import PickedPlayer from '../pickedPlayer';
import Tabs from '../tabs';
import AccordionChild from '../Accordion/accordionChild';
import PlayerLists from '../PlayerLists';
import NoDataFound from '../noDataFound';
import Accordion from '../Accordion';
import InputSearchBox from '../inputSearchBox';
import Loader from '../loader';
import Typo from '../typo';
import { IMG_BASE_PATH } from 'utils/constants';
import { playerSelection, resetPlayers } from 'store/slice/createTeamSlice';
import ToastMessage from '../toastMessage';
import { areArraysEqual } from 'utils/commonFunctions';

const OverlayPlayerList = ({
  onCancel,
  onConfirm,
  skillroles,
  matchDetails,
  bodyScroll,
  phaseData,
  playersIdFromApi,
  selectedPlayerId,
  playerPhaseData
}) => {
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const dispatch = useDispatch();
  const uniqueSkills = skillroles.filter((skill) =>
    filteredPlayers.some((player) => player.skill_name === skill)
  );
  const teamA = matchDetails?.home_team_short_name || { id: null, name: 'Team A' };
  const teamB = matchDetails?.away_team_short_name || { id: null, name: 'Team B' };
  const {
    data: data,
    error: PlayerError,
    isLoading: PlayerLoading
  } = usePlayerListsQuery(
    { gamedayId: matchDetails?.gameday_id },
    { skip: !matchDetails?.gameday_id, refetchOnMountOrArgChange: true }
  );
  const PlayerData = data?.Data?.Value;

  const userSelectedSkill = useSelector((state) => state?.overlay.showPlayerListOverlay);
  const selectedPlayers = useSelector((state) => state?.createTeam?.selectedPlayers || []);

  const [activeTab, setActiveTab] = useState('ALL');
  const [searchPlayer, setSearchPlayer] = useState('');
  const [activeIndex, setActiveIndex] = useState(0);
  const [openToast, setOpenToast] = useState(true);
  const [selectedPlayer, setSelectedPlayer] = useState(selectedPlayers);
  const [isInputActive, setIsInputActive] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const tabsData = ['ALL', teamA || 'Team A', teamB || 'Team B'];

  useEffect(() => {
    setSelectedPlayer(selectedPlayers);
  }, [selectedPlayers]);

  // Filter players based on active tab and search query
  useEffect(() => {
    if (PlayerData?.Players) {
      let players = PlayerData.Players;

      // Filter players based on the active tab
      if (activeTab !== 'ALL') {
        players = players.filter(
          (player) => player.team_short_name.toLowerCase() === activeTab.toLowerCase()
        );
      }

      // Apply search query filter
      if (searchPlayer) {
        players = players.filter((player) =>
          player.name.toLowerCase().includes(searchPlayer.toLowerCase())
        );
      }

      setFilteredPlayers(players);
    }
  }, [PlayerData, activeTab, searchPlayer]);

  // Handle add/remove player actions
  const handleAddRemovePlayer = (player) => {
    const teamCount = selectedPlayer.filter(
      (p) => p.team_short_name === player.team_short_name
    ).length;

    if (selectedPlayer.some((p) => p.id === player.id)) {
      setSelectedPlayer((prev) => prev.filter((p) => p.id !== player.id));
    } else if (teamCount < 2) {
      setSelectedPlayer((prev) => [...prev, player]);
    }
    dispatch(playerSelection({ ply: player }));
  };

  // Set the active accordion index based on the selected skill
  useEffect(() => {
    const roleIndex = skillroles.indexOf(userSelectedSkill);
    if (roleIndex !== -1) setActiveIndex(roleIndex);
  }, [userSelectedSkill /* , skillroles */]);

  const handleInput = (e) => {
    const value = e.target.value;
    setSearchPlayer(value);
    setInputValue(value);
  };

  const clearInput = () => {
    setSearchPlayer('');
    setInputValue('');
    setIsInputActive(false);
  };

  if (PlayerLoading || PlayerError) return <Loader />;

  const updateActiveIndex = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // useEffect(() => {
  //   const defaultRole = 'BATTER';
  //   const roleIndex = skillroles.indexOf(userSelectedSkill);

  //   if (roleIndex !== -1) {
  //     setActiveIndex(roleIndex);
  //   } else if (uniqueSkills.includes(defaultRole)) {
  //     setActiveIndex(skillroles.indexOf(defaultRole));
  //   }
  // }, [userSelectedSkill, skillroles]);

  const gameHeader = document.getElementsByClassName('si-gameHeader__wrap')?.[0]?.offsetHeight;
  const navHeader = document.getElementsByClassName('si-header')?.[0]?.offsetHeight;
  const footerHt = document.getElementsByClassName('si-popup__foot')?.[0]?.offsetHeight;
  const maxHeight = window.outerHeight - gameHeader - navHeader - footerHt;

  const myTeam = PlayerData?.Players?.filter((player) => playersIdFromApi?.includes(player.id));

  const handleReset = () => {
    dispatch(resetPlayers(myTeam));
  };

  // Create a mapping of player_id -> team_gameday_id
  const phasePlayerMap = {};
  playerPhaseData?.forEach(({ player_id, team_gameday_id }) => {
    player_id?.forEach((id, index) => {
      phasePlayerMap[id] = team_gameday_id[index];
    });
  });

  return (
    <div>
      <Overlays
        bodyScroll={bodyScroll}
        overlayName='selectPlayer'
        overlayConfig={{
          noOverlayHead: true,
          noOverlayFoot: true,
          noOverlayClose: true,
          submitBtn: true,
          title: 'SELECT PLAYERS',
          titleTransKey: 'overlay_title_select_players',
          onClickProp: onCancel,
          onConfirmClick: () => onConfirm(selectedPlayer),
          isDisabled: selectedPlayer.length === 0 ? true : false,
          btnPrimary: 'Confirm',
          btnPrimaryTransKey: 'cta_confirm'
        }}
        maxHeight={maxHeight}
      >
        <div className='si-popup__content'>
          <div className='si-selectPlayer__reset-wrap'>
            <PickedPlayer
              title={'Reset'}
              selectedPlayer={selectedPlayer}
              handleButtonClick={handleReset}
              isDisabled={
                playersIdFromApi?.length
                  ? areArraysEqual(selectedPlayerId, playersIdFromApi)
                  : selectedPlayer?.length === 0
              }
              variant={'secondaryOutline'}
            />
          </div>

          <div className='si-selectPlayer__tabs-grid'>
            <div className='si-selectPlayer__tabs-gridLhs'>
              <div className='si-selectPlayer__tabs'>
                <Tabs
                  customCls=''
                  data={tabsData}
                  handleClick={(tab) => setActiveTab(tab)}
                  isUnderline={true}
                  active={activeTab}
                />
              </div>
            </div>
            <div className='si-selectPlayer__tabs-gridRhs'>
              <div className='si-selectPlayer__search'>
                <div className='si-search'>
                  <InputSearchBox
                    inputType='text'
                    isIcon={'si-search'}
                    inputValue={searchPlayer}
                    handleInput={handleInput}
                    isInputActive={isInputActive}
                    clearInputValue={clearInput}
                    placeholderLabel='Search'
                    setIsInputActive={setIsInputActive}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='si-notification__fixed'>
            <ToastMessage
              open={true}
              type={3}
              transMessage={'toast_message_max_2_players_per_team'}
              message={'Max 2 players per team'}
            />
          </div>
        </div>
        {/* <div className={`si-notification in `}>
          <div className='si-notification__box si-info'>
            <div className='si-notification__icon'>
              <i className='lms-info'></i>{' '}
              <Typo component='div' className='si-notification__content'>
                Hello
              </Typo>
            </div>
          </div>
        </div> */}
        <Accordion
          data={skillroles}
          activeIndex={activeIndex}
          accordionChild={
            uniqueSkills?.length ? (
              uniqueSkills.map((role, index) => {
                const rolePlayers = filteredPlayers.filter((player) => player.skill_name === role);
                return (
                  <AccordionChild
                    key={index}
                    index={index}
                    isActive={activeIndex === index}
                    updateActiveIndex={() => updateActiveIndex(index)}
                    accordionHead={<div>{role}</div>}
                    bodyComponent={
                      rolePlayers.length > 0 ? (
                        <PlayerLists
                          players={rolePlayers.map((player) => ({
                            ...player,
                            isDisabled:
                              selectedPlayer.filter(
                                (p) => p.team_short_name === player.team_short_name
                              ).length >= 2
                          }))}
                          handleAddRemovePlayer={handleAddRemovePlayer}
                          selectedPlayer={selectedPlayer}
                          phasePlayerMap={phasePlayerMap}
                          isshow={true}
                          phaseshow={true}
                          phaseData={phaseData}
                          matchDetails={matchDetails}
                        />
                      ) : (
                        <NoDataFound
                          noDataThumb={`${IMG_BASE_PATH}images/no-data/no-player-selected.png`}
                          noDataCaption={
                            window?.['translations']?.['no_player_found'] || 'No Players Found.'
                          }
                        />
                      )
                    }
                    accordionConfig={{ showAccordArrow: true }}
                  />
                );
              })
            ) : (
              <NoDataFound
                noDataThumb={`${IMG_BASE_PATH}images/no-data/no-player-selected.png`}
                noDataCaption={window?.['translations']?.['no_player_found'] || 'No Players Found.'}
              />
            )
          }
        />
      </Overlays>
    </div>
  );
};

export default OverlayPlayerList;
